import { Theme } from '@mui/material/styles';
import { Trans } from 'react-i18next';

import { ProgressDots } from '@/components/DataDisplay/Indicator/ProgressDots';
import { Page } from '@/components/Layout/Page/Page';

import { getAssetPath } from '@/constants/configs';

import { useResponsive } from '@/hooks/useResponsive';
import { useTranslate } from '@/hooks/useTranslate';

import { ClientType } from '@/types/user';

import {
  getProgressSteps,
  MobileAdoptionProgressSteps,
} from '@/utils/progressSteps';

import { IdentifyCustomerForm } from './components/IdentifyCustomerForm';

import {
  IdentifyCustomerContainer,
  IdentifyCustomerDescription,
  IdentifyCustomerTitle,
  IdentifyCustomerTitleHighlight,
} from './IdentifyCustomer.styled';

export function IdentifyCustomerPage() {
  const { isMobile } = useResponsive();
  const { language } = useTranslate();
  const progressSteps = getProgressSteps(
    ClientType.MobileAdoption,
  ) as MobileAdoptionProgressSteps;
  return (
    <Page
      paperProps={{
        color: (theme: Theme) => theme.palette.neutral[1000],
        position: 'right',
        size: 'medium',
        ...(isMobile
          ? {}
          : {
              fgImgProps: {
                src: getAssetPath(`/republic-protects-data-${language}.png`),
                overflowPercent: 50,
                width: 294,
              },
            }),
      }}
      hasLogo
      progressProps={progressSteps.confirmIdentityStep}
      headerMobile={{
        centerSlot: <ProgressDots {...progressSteps.confirmIdentityStep} />,
        bgColor: (theme: Theme) => theme.palette.background.paper,
      }}
    >
      <IdentifyCustomerContainer>
        <IdentifyCustomerTitle>
          <Trans
            i18nKey="mobileAdoption.identifyCustomer.title"
            lang={language}
            components={{ a1: <IdentifyCustomerTitleHighlight as="span" /> }}
          />
        </IdentifyCustomerTitle>
        <IdentifyCustomerDescription>
          <Trans
            lang={language}
            i18nKey="mobileAdoption.identifyCustomer.description"
            components={{
              a1: <strong />,
            }}
          />
        </IdentifyCustomerDescription>
      </IdentifyCustomerContainer>
      <IdentifyCustomerForm />
    </Page>
  );
}

export default IdentifyCustomerPage;
